import React, { useEffect, useRef, useState } from 'react'
import * as API from '../../../framework/API/api'
import { useTranslation } from '../../../locale/useTranslation'
import { utility } from '../../../framework/utility/utilityProvider'
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import BossDialog from '../../../components/BossDialog'
import { MEDIACATEGORIES, MONTHNUMBER, SCHEDULETYPE, TOAST_TYPES } from '../../../framework/constant/constant'
import MyStatusCell from '../../../components/MyStatusCell'
import { ConfirmAlert } from '../../../ConfirmAlert';
import { PlanningHelper } from '../../Planning/helper/PlanningHelper';
import ToastNotification from '../../../components/ToastNotification';

const ImportCommercialPopup = (props) => {
    const { schedulerData } = props;
    const lang = useTranslation();
    const [gridData, setGridData] = useState([]);

    const [fileDataItem, setFileDataItem] = useState({ file: "" });
    const fileRef = useRef(null);
    const [file, _setFiles] = useState({});
    const setFile = (data) => {
        _setFiles(data);
        fileRef.current = data;
    }

    const [importCommercialProgress, setImportCommercialProgress] = useState({ message: "", progress: 0 });

    useEffect(() => {
        console.log(props.importCommercialProgress)
        setImportCommercialProgress({
            message: props.importCommercialProgress?.message,
            progress: props.importCommercialProgress?.progress
        });
    }, [
        props.importCommercialProgress?.progress,
        props.importCommercialProgress?.message
    ]);


    const handleFileChange = async (e) => {

        console.log(e.target.files[0])

        setFileDataItem({ ...fileDataItem, [e.target.name]: e.target.value });
        setFile(e.target.files[0]);

    };

    const loadAndVerifyDataFromFile = async () => {

        if (fileRef.current == null) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please select a file to import` });
            return;
        }

        setImportCommercialProgress({ message: '', progress: 0 });

        if (schedulerData == null || schedulerData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `No Schedule Data found !!` });
            return;
        }
        const mainTimeZone = PlanningHelper.getMainTimeZone([{ SID: props.scheduleMediaLibraryPayload.channelSID }])

        let res = await API.readFile(fileRef.current);
        console.log(res);

        if (res.success && res.data && res.data.data && res.data.data.length > 0) {

            let fileData = res.data.data;

            //CONDITIONS 1 : Check schedule date and the file date 
            let fileNameParts = fileRef.current.name.split('.')[0].split("-")
            let fileDate = `${fileNameParts[1]}-${fileNameParts[2]}-${fileNameParts[3]}`; // 18-11-2025
            let scheduleDate = `${(props.date.getUTCDate()).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}-${MONTHNUMBER[props.date.getUTCMonth()]}-${props.date.getUTCFullYear()}`; // 18-11-2025

            console.log(fileDate);
            console.log(scheduleDate);

            // match string to string
            if (fileDate != scheduleDate) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_date_and_schedule_date_mismatch });
                return;
            }

            let localGridData = [];
            let currentBaseObj = {};

            //NEW
            for (let i = 3; i < fileData.length; i++) {
                const item = fileData[i];

                // Skip invalid or empty rows
                if (!item || item.length === 0) continue;

                // Detect SlotTime and ProgramName row
                if (typeof item[0] === "string" && item[0].includes(":") && !item[0].includes("Break Name")) {

                    // only reset if program changes, handled by vishal on 6 dec 2025
                    if (currentBaseObj.SlotTime != item[0] || currentBaseObj.ProgramName != item[4]) {
                        currentBaseObj = {
                            SlotTime: item[0],
                            ProgramName: item[4],
                            BreakNo: 0 // Reset break counter per program
                        };
                    }

                    continue;
                }

                // Detect Break Name row
                if (typeof item[0] === "string" && item[0].includes("Break Name")) {
                    currentBaseObj.Segment = item[3];
                    // currentBaseObj.BreakNo = currentBaseObj.BreakNo + 1 || 1;
                    currentBaseObj.BreakNo = item[3].includes("Opening") ? 0 : currentBaseObj.BreakNo + 1 || 1;
                    continue;
                }

                // Detect Asset/Ad row
                if (typeof item[0] === "number") {
                    // Basic validation before accessing indices
                    if (!item[13] || isNaN(item[13])) {
                        console.warn("Invalid duration at row", i);
                        continue;
                    }

                    const obj = {
                        SlotTime: currentBaseObj.SlotTime || '',
                        ProgramName: currentBaseObj.ProgramName || '',
                        Segment: currentBaseObj.Segment || '',
                        BreakNo: currentBaseObj.Segment && currentBaseObj.Segment.includes("Opening") ? 0 : currentBaseObj.BreakNo || 1,
                        // BreakNo: currentBaseObj.BreakNo || 1,
                        Sequence: item[0],
                        AssetId: item[1],
                        Brand: item[6],
                        Title: item[10],
                        Duration: parseInt(item[13]) * 1000 // milliseconds
                    };

                    localGridData.push(obj);
                }
            }

            // setGridData(localGridData);


            //CONDITIONS 2 : VERIFY

            //FETCH COMMERCIALS FROM LOAD SCHEDULE MEDIA LIBRARY API
            let commercialAssetIds = [...new Set(localGridData.map(item => item.AssetId))];

            console.log("UNIQUE ASSET ID's");
            console.log(commercialAssetIds.length);

            let commercialsRes = await API.loadSchedulingMediaLibrary(
                '',
                {},
                props.scheduleMediaLibraryPayload,
                true,
                { per_page: 1000, current_page: 1, orderby: 'SID', direction: 'asc' },
                false,
                commercialAssetIds
            );

            localGridData = localGridData.map((item) => {

                let scheduleHeader = schedulerData.find((h) =>
                    // utility.convertMilisecondsToShortTimeString(h.SlotDateTime) == item.SlotTime
                    utility.getTimeByTimeZone(h.SlotDateTime, mainTimeZone?.IsNegativeOffset, mainTimeZone?.Offset, null, true) == `${item.SlotTime}:00:00`
                );

                if (scheduleHeader == null) {
                    return { ...item, Status: "Program Header Not Found", CommercialEntity: null }
                };

                //HANDLE OPENINGS
                // let segment = 
                //     item.Segment.includes('Opening') && item.BreakNo == 0 ? 
                //     scheduleHeader : 
                //     scheduleHeader.children.find((s) => s.Type == SCHEDULETYPE.Segment && s.BreakNo == item.BreakNo);

                // Segment verification logic changed by vishal on 6 dec 2025, to handle grouped segments like at placement logic.
                // back to back segments are treated as one.
                let isGroupSegments = scheduleHeader.children.some((item) =>
                    item.Type != SCHEDULETYPE.Segment && item.mediaEpisode?.MediaCateogry?.SID != MEDIACATEGORIES.Commercial && item.Type != SCHEDULETYPE.UnderRun && item.Type != SCHEDULETYPE.OverRun
                );

                let segment =
                    item.Segment.includes('Opening') && item.BreakNo == 0
                        ? scheduleHeader
                        : props.getCommcialBreakDropDestination(scheduleHeader, item.BreakNo, isGroupSegments);


                // let segment = scheduleHeader.children.find((s) => s.Type == SCHEDULETYPE.Segment && s.BreakNo == item.BreakNo);

                if (segment == null) {
                    return { ...item, Status: "Program Segment Not Found", CommercialEntity: null }
                }

                let commercial = commercialsRes.success && commercialsRes.data && commercialsRes.data.find((com) => com.AssetId == item.AssetId);

                if (!commercial) {
                    return { ...item, Status: "Missing Commercial", CommercialEntity: null }
                }

                return { ...item, Status: "Ready", CommercialEntity: commercial }
            })


            console.log(localGridData)

            setGridData(localGridData);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.data_loaded_successfully_ingestion_template_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.data?.columns.length == 0 ? "Not data found" : "Error Loading Data. Please try again !!" });
        }
    }

    const onImportCommercialFile = async () => {

        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please load the file before importing commercials` });
            return;
        }

        console.log("HERE IN IMPORT COMMERCIAL FILE");
        setImportCommercialProgress({ message: 'Importing commercials..', progress: 0 });

        let hasInvalidLine = gridData.some((x) => x.Status != "Ready");

        if (hasInvalidLine) {
            ConfirmAlert(
                () => {
                    props.onImportCommercialFile(gridData);
                }, // on Click yes
                () => { }, // on click no
                'Confirm', //title
                'Do you really want to import commercials with all these invalid lines ?'
            )

        } else {
            props.onImportCommercialFile(gridData);
        }

    }

    const StatusCell = (props) => {

        const field = props.field;
        let value = props.dataItem[field];

        let tileBackColor = value == "Ready" ? "#5CB338" : "#FB4141";

        return <MyStatusCell {...props} title={value} tileBackColor={tileBackColor} />
    };

    return (
        <BossDialog
            title={lang.import_commercials}
            onClose={props.onClose}
            width={"80vw"}
        >
            <div className="row" style={{ margin: "5px" }}>


                <div className="col-md-7 col-sm-4 col-xs-4" style={{ marginTop: "5px", padding: '0px' }}>
                    <input type="text" className="form-control form-control-sm" name="filename" value={fileDataItem.file ?? ""} disabled={true} />
                </div>

                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4" style={{ margin: "5px", padding: '0px' }}>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary" style={{ height: "32px" }}>
                        <label className="fa-solid fa-ellipsis-h" style={{ cursor: 'pointer' }}>
                            <input id="fileupload" name="file" className='custom-file-updated-input form-control form-control-sm' type="file" hidden="hidden" onChange={handleFileChange} />
                        </label>
                    </button>

                    <button title="Verify" type="button" onClick={loadAndVerifyDataFromFile} className="btn-square btn-primary" >
                        {lang.verify_button_text}
                    </button>
                    <button title="Import" type="button" onClick={onImportCommercialFile} className="btn-square btn-success" >
                        {lang.import_commercial_file_label}
                    </button>
                </div>

            </div>
            <Grid data={gridData} style={{ height: "50vh" }} resizable={true}>
                <Column field='Status' title='Status' cell={StatusCell} width={200} />
                <Column field='SlotTime' title='Slot Time' width={80} />
                <Column field='ProgramName' title='Program Name' width={200} />
                <Column field='Segment' title='Segment' width={200} />
                <Column field='BreakNo' title='Break No' width={80} />
                <Column field='Sequence' title='Sequence' width={80} />
                <Column field='AssetId' title='Asset Id' width={150} />
                <Column field='Title' title='Title' width={220} />
                <Column field='Brand' title='Brand' width={150} />
                <Column field='Duration' title='Duration' cell={TimeCell} />
            </Grid>
            <div style={{ display: 'flex', justifyContent: "space-between", margin: 0, backgroundColor: "black", color: "white" }}>
                <div>
                    <div style={{ margin: '5px 0px 4px 10px', fontSize: "13px", marginRight: '20px' }}>
                        {importCommercialProgress ? `${`${importCommercialProgress.progress}%`} ${importCommercialProgress.message}` : ""}
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                    <div style={{ margin: '5px 10px 4px 0px', fontSize: "13px", marginRight: '20px' }}>
                        {"VALID"} : {gridData?.filter(x => x.Status == "Ready")?.length ?? 0}
                    </div>
                    <div style={{ margin: '5px 10px 4px 0px', fontSize: "13px", marginRight: '20px' }}>
                        {"INVALID"} : {gridData?.filter(x => x.Status != "Ready")?.length ?? 0}
                    </div>
                    <div style={{ margin: '5px 10px 4px 0px', fontSize: "13px" }}>
                        {lang.total_count_label} : {gridData?.length ?? 0}
                    </div>
                </div>
            </div>

        </BossDialog >
    )
}

export default ImportCommercialPopup